import CampaignFromTemplateCreatePage from "./CampaignFromTemplateCreatePage";

export default CampaignFromTemplateCreatePage;
